import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=03083004"
var script = {}
import style0 from "./Why.vue?vue&type=style&index=0&id=03083004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports